<script>
// eslint-disable-next-line no-unused-vars
import CalendarApiService from '@/services/calendarService';

export default {
    data() {
        return {
            templatesFilter: this.$store.getters['calendar/templates'],
            templatesOptions: [],
        };
    },
    created() {
        CalendarApiService.getAllTemplatesList().then((response) => {
            let templates = response.data.data;
            console.log(templates);

            this.templatesOptions = this.templatesOptions.concat(templates);
        });
    },
    methods: {
        selectTemplate() {
            this.$store.commit('calendar/setTemplates', this.templatesFilter);
            this.$nextTick(() => {
                this.$emit('reloadCalendarEvents');
            });
        },
    },
};
</script>
<template>
    <multiselect
        id="templatesFilters"
        style="width: 100%"
        v-model="templatesFilter"
        class="mb-1"
        :options="templatesOptions"
        label="name"
        track-by="idPublic"
        :show-labels="false"
        @input="selectTemplate"
        :multiple="true"
        :placeholder="$t('general.selectTemplates')"
    >
    </multiselect>
</template>
